"use strict";
/*
 * Created on 09 10 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var RegularProductPriceConverter_1 = require("../../product/conversions/RegularProductPriceConverter");

var ZonePrices_1 = require("../model/ZonePrices");

var ZonePricesConverter_1 = require("./ZonePricesConverter");
/**
 * <p>Implementation of {@link ZonePricesConverter}.</p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */


var ZonePricesConverterImpl =
/*#__PURE__*/
function (_ZonePricesConverter_) {
  _inherits(ZonePricesConverterImpl, _ZonePricesConverter_);

  function ZonePricesConverterImpl(regularProductPriceConverter) {
    var _this;

    _classCallCheck(this, ZonePricesConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZonePricesConverterImpl).call(this));
    _this.regularProductPriceConverter = regularProductPriceConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ZonePricesConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ZonePrices_1.ZonePrices(conversions.asObject(source, 'priceZoneId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'regularPrice', function (doc) {
        return _this2.regularProductPriceConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {};
      Object.assign(result, {
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        regularPrice: conversions.asObjectOpt(source, 'regularPrice', function (obj) {
          return _this3.regularProductPriceConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
  }]);

  return ZonePricesConverterImpl;
}(ZonePricesConverter_1.ZonePricesConverter);

ZonePricesConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [RegularProductPriceConverter_1.RegularProductPriceConverter])], ZonePricesConverterImpl);
exports.ZonePricesConverterImpl = ZonePricesConverterImpl;